import React, { useEffect, useState } from 'react';
import { Form, Spinner, Card } from 'react-bootstrap';
import axios from "../../constents/axios";
import { FaUpload } from "react-icons/fa6";
import { FaDownload } from "react-icons/fa6";

const Live = () => {
  const [selectedSubject, setSelectedSubject] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleInputChange = async (e) => {
    const value = e.target.value;
    console.log("Selected Subject:", value);
    
    setSelectedSubject(value);

    if (value) {
      setLoading(true);
      try {
        const { data } = await axios.get(`/getAllLiveVideos/${value}`);
        setVideos(data);
      } catch (error) {
        console.error("Error fetching live videos:", error);
        setVideos([]);
      } finally {
        setLoading(false);
      }
    } else {
      setVideos([]);
    }
  };

  // Fetch available subjects
  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const { data } = await axios.get("/getPremiumSubjects");
        setSubjects(data);
      } catch (error) {
        console.error("Error fetching subjects:", error);
        setSubjects([]);
      }
    };
    fetchSubjects();
  }, []);

  return (
    <div className=" mt-4">
      <h1>Live Videos</h1>

      <Form className="row">
        <Form.Group className="mt-3 col-md-6 col-12">
          <Form.Label>Choose Subject</Form.Label>
          <Form.Control
            as="select"
            name="selectedSubject"
            value={selectedSubject}
            onChange={handleInputChange}
          >
            <option value="">Select Subject</option>
            {subjects.map((subject, index) => (
              <option key={index} value={subject.subject}>
                {subject.subject}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      </Form>

      <div className="mt-4">
        {loading && <Spinner animation="border" variant="primary" />}
        {!loading && videos.length === 0 && selectedSubject && (
          <p>No live videos available for this subject.</p>
        )}
        <div className="row" style={{ height: '70vh', overflowY: 'scroll',  }}>
          {videos.map((video, index) => (
              <div className='col-md-3 col-12 mt-2'>
            <Card key={index}>
              <Card.Body>
                <Card.Title>{video.course_title}</Card.Title>
                <Card.Text>Topic : {video.topics}</Card.Text>
                <Card.Text>Subtopic : {video.subtopics === "" ? video.topics : video.subtopics}</Card.Text>
                {video.transcode_source && (
                  <video controls width="100%" style={{ borderRadius: '15px', maxHeight: '200px' }}>
                    <source src={video.transcode_source} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
                <strong>Progress</strong>
                <div className='row mt-2'>
                  <div className='col-6'>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center', backgroundColor: video.transcode_status === "Completed" ? '#05802c' : video.transcode_status === "In Progress" ? '#ffcc00' : '#ff0000', color: '#fff', padding: '5px', borderRadius: '5px' }}>
                  <FaUpload />{video.transcode_status}
                    </div>
                  </div>
                  <div className='col-6' >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center', backgroundColor: video.mp4_transcode_status === "Completed" ? '#05802c' : video.mp4_transcode_status === "In Progress" ? '#ffcc00' : '#ff0000', color: '#fff', padding: '5px', borderRadius: '5px' }}>
                  <FaDownload />{video.mp4_transcode_status}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
              </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Live;
